var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrganisationCream(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 47 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #f4efe5;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-width: 2px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\xEB\\xEE\\xE9_1",
    "data-name": "\\u2018\\xEB\\xEE\\xE9_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1,
    y: 35.76,
    width: 9.73,
    height: 10.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 18.64,
    y: 35.76,
    width: 9.73,
    height: 10.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 36.27,
    y: 35.76,
    width: 9.73,
    height: 10.24
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.14,32.11v-3.95c0-1.26-.97-2.28-2.16-2.28H8.03c-1.2,0-2.16,1.02-2.16,2.28v3.95"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 23.5,
    y1: 32.11,
    x2: 23.5,
    y2: 17.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 15.05,
    y: 1.42,
    width: 16.9,
    height: 16.06,
    transform: "translate(14.05 32.95) rotate(-90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganisationCream);
export default __webpack_public_path__ + "static/media/organisation-cream.caf77953a511c4ab8e11b62d6e46708d.svg";
export { ForwardRef as ReactComponent };